import Vue from 'vue'
import {getToken} from "@/api/auth"
import Router from 'vue-router'

import index from '@/pages/index/index'
import schoolList from '@/pages/schoolList/index'
import payInput from '@/pages/payInput/index'
import payInfo from '@/pages/payInfo/index'
import payment from '@/pages/payment/index'
import paymentScan from '@/pages/payment-scan/index'
import paymentCounty from '@/pages/payment-county/index'

var routerPush = Router.prototype.push
Router.prototype.push = function push(location){
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router);

const router = new Router({
  // mode: "history",
  routes: [
    {
      path:'/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/schoolList',
      name: 'schoolList',
      component: schoolList
    },
    {
      path: '/payInput',
      name: 'payInput',
      component: payInput
    },
    {
      path: '/payInfo',
      name: 'payInfo',
      component: payInfo
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    {
      path: '/payment-scan',
      name: 'payment-scan',
      component: paymentScan
    },
    {
      path: '/payment-county',
      name: 'payment-county',
      component: paymentCounty
    }
  ]
})

// const whiteList = ['/', 'index', '/login', '/join', '/feedback', '/login/forget', '/news', '/news/detail', '/help'] //免登录白名单
//
// router.beforeEach((to, from, next) => {
//   if (getToken()) {
//     if (to.path === '/login') {
//       next({ path: '/' })
//     } else {
//       next({to, replace: true})
//     }
//   } else {
//     if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
//       next()
//     } else {
//       next(`/login`) // 否则全部重定向到首页
//     }
//   }
// })
// router.beforeEach((to, from, next) => {
//
// })


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js